<template>
    <div :class="[
    'component',
    'component__icon',
    size ? `component__icon--${size}` : '',
    theme ? `component__icon--${theme}` : ''
    ]">
        <v-icon :name="iconName"></v-icon>
    </div>
</template>

<script>
export default {
  name: 'component-icon',
  data () {
    return {
      errorLoading: false
    }
  },
  props: {
    iconName: {
      type: String,
      default: ''
    },
    size: {
      type: String
    },
    theme: {
      type: String
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componenticon";
</style>
